import * as tslib_1 from "tslib";
import * as React from 'react';
/**
 * React hook that provides a standard way to generate async callbacks by returning an array containing:
 *  1. a wrapped callback function
 *  2. a status object including:
 *      i. An executing flag
 *      ii. an error result created from any raised exceptions
 *      iii. an success flag that can be used if success is not otherwise indicated (often ignored and not captured from the returned values).
 *
 * @param callback Async callback that will be wrapped with the extended functionality and returned.
 * @param deps Dependencies passed to React's useCallback()
 */
export function useAsyncCallback(callback, deps) {
    var _this = this;
    var _a = React.useState(false), isExecuting = _a[0], setIsExecuting = _a[1];
    var _b = React.useState(undefined), error = _b[0], setError = _b[1];
    var _c = React.useState(false), success = _c[0], setSuccess = _c[1];
    var wrappedCallback = React.useCallback(function () {
        var argsx = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsx[_i] = arguments[_i];
        }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var ret, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsExecuting(true);
                        setSuccess(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, callback.apply(void 0, argsx)];
                    case 2:
                        ret = _a.sent();
                        setSuccess(true);
                        setError(undefined);
                        setIsExecuting(false);
                        return [2 /*return*/, ret];
                    case 3:
                        e_1 = _a.sent();
                        setError(e_1);
                        setIsExecuting(false);
                        // Pass on the exception so existing exception handling can handle it.
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, deps.concat([setIsExecuting, setError]));
    return [wrappedCallback, { isExecuting: isExecuting, errors: error, successfullyExecuted: success }];
}
//# sourceMappingURL=useAsyncCallback.js.map